import { render, staticRenderFns } from "./AdminReportTab.vue?vue&type=template&id=5937b7fe"
import script from "./AdminReportTab.vue?vue&type=script&lang=js"
export * from "./AdminReportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports